<div class="disable-confirm-container">
  <p class="disable-confirm-title alt-inter-bold alt-size-20">{{"USERS.dshabilit" | translate }} </p>
  <p class="disable-confirm-text-one alt-size-14 alt-inter-semibold ">{{"USERS.disabled-text-modal" | translate}}
    "{{data.title}}" ?</p>
  <small class="disable-confirm-text-two alt-size-14 alt-inter-regular">{{"USERS.disabled-text-two" |
    translate}}</small>


  <div class="btn-proceed alt-flex-end">
    <button class="btn-cancel alt-color-bran1 pointer  alt-inter-medium alt-size-14" type="button"
      [mat-dialog-close]="true">{{"USERS.go-back" | translate | uppercase }}</button>
    <button class="btn-agree alt-color-bran1 pointer alt-inter-medium alt-size-14" type="button"
      [mat-dialog-close]="false">{{"USERS.agree-disabled" | translate | uppercase
      }}</button>
  </div>
</div>
